import { createApiCallActions } from "src/app/common/store/generic.actions";
import { BankModel } from "./types";

export const bankActions = {
    getById: createApiCallActions<BankModel>('bank', 'getById'),
    postBank: createApiCallActions<BankModel>('bank','postBank'),
    updateBank: createApiCallActions<BankModel>('bank', 'updateBank')
};

export type BankAction = typeof bankActions;